import React, { useEffect, useState } from 'react';
import PopupMessage from 'Components/Common/PopupMessage';
import SuccessPopup from './SuccessPopup';

const Import = (props) => {
    const [ errorMessage, setErrorMessage ] = useState(null);
    const [ importSuccessPopup, setImportSuccessPopup ] = useState(false);

    useEffect(() => {
        if(!props.appAccessControlImportUsers?.loading && !props.appAccessControlImportUsers?.error && props.appAccessControlImportUsers?.data){
            setImportSuccessPopup(!importSuccessPopup);
        }
    }, [ props.appAccessControlImportUsers ]);

    const openFile = () => {
        document.getElementById('aac_import_file').click();
    }

    const validateFile = (file) => {
        if(file.type !== 'text/csv'){
            setErrorMessage('Invalid format. Please upload CSV file only');
            return;
        }
        return true;
    }

    const handleFileChange = (e) => {
        const file = e.target.files[ 0 ];
        const isValidFile = validateFile(file);
        if(isValidFile){
            props.appAccessControlImportUsersAction(file, props.filteredWithSort);
        }
    }

    const handleClosePopup = () => {
        setErrorMessage(null);
    }

    const toggleImportSuccessPopup = () => {
        const dataToBeUpdated = !importSuccessPopup
        setImportSuccessPopup(dataToBeUpdated);
        if(!dataToBeUpdated){
            props.appAccessControlImportUsersSuccess();
        }

    }
    
    return (
        <>
            <button className='btn btn_primary_outline' onClick={ openFile }>Import</button>
            <input type='file' id='aac_import_file' onChange={ handleFileChange } onClick={ (event)=> { event.target.value = null } }  accept='.csv' hidden/>
            { errorMessage && <PopupMessage message={ errorMessage } closePopup={ handleClosePopup }/> }
            { importSuccessPopup && <SuccessPopup { ...props } toggleImportSuccessPopup={ toggleImportSuccessPopup } /> }            
        </>
    )
}

export default Import